import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import ConfigurationActions from '../../redux/configurationRedux';
import PartsActions from '../../redux/partsRedux';
import ShownStepsActions from '../../redux/shownStepsRedux';
import { isNil } from '../../services/helper';
import style from '../scenes.scss';

// Components
import DefaultBox from '../../components/selectionBoxes/defaultBox/defaultBoxComponent';
import SceneNotice from '../../components/notice/sceneNoticeComponent';
import getFlattenedConfiguration from '../../redux/selectors/getFlattenedConfiguration';
import checkDependencies from '../../services/dependencies';
import resolvePrice from '../../services/helper/resolvePrice';
import checkMarkedDependency from '../../services/helper/checkMarkedDependency';

class OptionalEquipmentScene extends Component {

    componentWillMount() {
        this.listItems();
    }

    listItems = () => {
        const { listPartsRequest, parts, configuration } = this.props;
        if (isNil(parts.lastrada) || configuration.refreshing) {
            listPartsRequest('all', configuration.model.id);
            this.props.setRefreshing(false);
        }
    }

    onSelectItem = (lastrada) => {
        const { configuration, updateConfiguration, parts } = this.props;
        if (!isNil(lastrada) && !lastrada.disabled) {
            let selectedItems = [...configuration.configurations.lastrada]; // eslint-disable-line prefer-const, max-len

            const index = selectedItems.findIndex(
                (selectedItem) => selectedItem.uid === lastrada.uid
            );

            if (index !== -1) {
                selectedItems.splice(index, 1);
            } else {
                const inclusiveOrs = lastrada.inclusive_or;
                selectedItems.forEach((selectedItem, selectedItemIndex) => {
                    if (inclusiveOrs.indexOf(selectedItem.uid) !== -1) {
                        selectedItems.splice(selectedItemIndex, 1);
                    }
                });
                selectedItems.push(lastrada);
            }
            updateConfiguration('lastrada', selectedItems, parts, lastrada);
        }
    }

    setPreselectedItems = () => {
        const {
            navigation,
            shownSteps,
            addShownStep,
            parts,
            configuration,
            updateConfiguration,
        } = this.props;
        let selectedItems = [...configuration.configurations.lastrada]; // eslint-disable-line prefer-const, max-len

        // Early return, if the step has already been rendered before
        if (shownSteps.indexOf(navigation.active) > -1) {
            return;
        }

        parts.lastrada.data.forEach((item) => {
            if (item.preselected || item.mandatory) {
                const index = configuration.configurations.lastrada.indexOf(item);
                if (index === -1) {
                    selectedItems.push(item);
                    updateConfiguration('lastrada', selectedItems, parts);
                }
            }
        });
        addShownStep(navigation.active);
    }

    resolvePrice = (part, serialParentUid) => resolvePrice(
      part, serialParentUid, this.props.configuration.configurations
    );

    disableParts = (parts) => {
        const { configuration, updateConfiguration, flatConfigurationParts } = this.props;
        const disabledParts = checkDependencies(parts, flatConfigurationParts);

        let selectedItems = [...configuration.configurations.lastrada]; // eslint-disable-line prefer-const, max-len
        selectedItems.forEach((item, index) => {
            if (disabledParts.indexOf(item.uid) !== -1) {
                selectedItems.splice(index, 1);
                updateConfiguration('lastrada', selectedItems, parts);
            }
        });

        return parts.map((part) => {
            if (disabledParts.indexOf(part.uid) !== -1) {
                return { ...part, disabled: true };
            }
            return part;
        });
    };

    renderLastradaItems = () => {

        const { parts, configuration } = this.props;

        if (isNil(parts.lastrada)) {
            return null;
        }

        this.setPreselectedItems();

        const itemList = this.disableParts([...parts.lastrada.data]);

        const listItems = itemList.map((lastradaItem) => (
            <DefaultBox
                key={lastradaItem.uid}
                item={lastradaItem}
                selectedItems={configuration.configurations.lastrada}
                markedDependencies={configuration.markedDependencies}
                onSelectItem={(item) => this.onSelectItem(item)}
                parts={parts}
                configuration={configuration.configurations}
                resolvePrice={this.resolvePrice}
            />
        ));

        return (
            <div className={style.form_container_5}>
                {listItems}
            </div>
        );
    }

    render() {
        const { parts, configuration } = this.props;

        if (this.props.fetching === null || this.props.fetching === true) {
            return (
                <h2>{t`LADE`}</h2>
            );
        }
        let hasMarkedDependency = false;
        hasMarkedDependency = checkMarkedDependency(
            parts.lastrada.data,
            configuration.markedDependencies
        );
        return (
            <div className={style.scene}>
                <div className={style.title}>
                    <h2>{t`Sonderausstattungen`}</h2>
                </div>
                <form>
                    {
                        hasMarkedDependency ?
                            <SceneNotice content={t`Sie haben nun die Möglichkeit Ihre Konfiguration zu ändern. Eine Änderung kann ggf. Auswirkungen auf die bestehende Konfiguration haben. Bitte prüfen Sie die folgenden Einstellungen!`} />
                            : null
                    }
                    {this.renderLastradaItems()}
                </form>

            </div>
        );
    }
}
const mapStateToProps = state => ({
    caravans: state.caravans.caravans,
    parts: state.parts.parts,
    fetching: state.parts.fetching,
    configuration: state.configuration,
    flatConfigurationParts: getFlattenedConfiguration(state.configuration.configurations),
    navigation: state.navigation,
    shownSteps: state.shownSteps,
});

const mapDispatchToProps = dispatch => ({
    updateConfiguration: (category, value, parts, changedItem) =>
        dispatch(ConfigurationActions.updateConfiguration(category, value, parts, changedItem)),
    listPartsRequest: (category, identifier) =>
        dispatch(PartsActions.listPartsRequest(category, identifier)),
    setRefreshing: (refresh) =>
        dispatch(ConfigurationActions.setRefreshing(refresh)),
    addShownStep: (stepId) =>
        dispatch(ShownStepsActions.addShownStep(stepId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OptionalEquipmentScene);
